import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Alert from 'react-bootstrap/Alert'
import { connect } from 'react-redux'
import { SnackBar } from '../hooks/Common'

const mapStateToProps = (state) => {
    return {
        common: state.common
    }
}

const mapDispatchToProps = dispatch => ({
    SnackBar: (show, message, variant) => dispatch(SnackBar(show, message, variant)),
});

class AlertPage extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            show: true
        };
    }

    componentDidUpdate() {
        if (this.props.common.alert.show) {
            clearTimeout(this.timer)
            this.timer = setTimeout(() => {
                this.props.SnackBar(false, "", null)
            }, 1700)
        }
    }

    render() {
        return <div className="snack-alert">
            {this.props.common.alert.show ?
                <Alert variant={this.props.common.alert.variant} dismissible>
                    <p> {this.props.common.alert.message} </p>
                </Alert> : null}
        </div>
    }
}

AlertPage.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(AlertPage);

// primary - blue
// success - green
// danger - red
// warning - warning
// info - light blue

